import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Network, ArrowRight, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4">
      <Helmet>
        <title>Page Not Found | System Design Lab</title>
        <meta name="description" content="The page you're looking for doesn't exist." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Logo */}
      <div className="flex items-center gap-3 mb-12">
        <div className="w-9 h-9 bg-primary rounded-sm flex items-center justify-center">
          <Network className="w-5 h-5 text-white" />
        </div>
        <span className="text-lg font-bold tracking-tight">System Design Lab</span>
      </div>

      {/* 404 content */}
      <div className="text-center max-w-md">
        <p className="text-8xl font-bold text-zinc-800 mb-4 select-none">404</p>
        <h1 className="text-2xl font-semibold text-foreground mb-3">Page not found</h1>
        <p className="text-muted-foreground text-sm mb-8 leading-relaxed">
          The page you're looking for doesn't exist or may have been moved.
          Head back to the home page to continue your prep.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-primary hover:bg-primary/90 text-white rounded-sm uppercase tracking-wide font-medium text-sm"
          >
            <Home className="w-4 h-4 mr-2" />
            Go to Home
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
            variant="outline"
            className="border-zinc-700 hover:bg-zinc-800 rounded-sm uppercase tracking-wide font-medium text-sm"
          >
            My Dashboard
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
